import { useRoute } from '#imports'
import { computed } from 'vue'

import { getReviews } from '@backmarket/http-api/src/api-specs-reviews/product-reviews'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'
import { MAX_REVIEWS_DISPLAYED_IN_LIST } from '~/scopes/reviews/reviews-display/constants'
import { transformReviewsResponse } from '~/scopes/reviews/reviews-display/utils/transformReviewsResponse'

// @FIXME: migrate to HTTP2 + add test
export function useFetchReviews() {
  const { productId } = useUrlParams()
  const route = useRoute()
  const experiments = useExperiments()
  const locale = useI18nLocale()

  const reviewsQueryParams = computed(() => ({
    ...route.query,
    page_size:
      experiments['experiment.reviewAmount'] === 'tenReviews'
        ? 10
        : MAX_REVIEWS_DISPLAYED_IN_LIST,
    translation_locale: locale,
    order_by: route.query.order_by ?? '-relevance_alt',
  }))

  return useHttpFetch(getReviews, {
    headers: { 'BM-Page-Name': route.name },
    pathParams: { uuid: productId },
    queryParams: reviewsQueryParams,
    transform: ({ results, previousCursor, nextCursor }) => ({
      results: transformReviewsResponse(results),
      previousCursor,
      nextCursor,
    }),
    // Timeout reduced from 5s to 2s to mitigate 500 errors on product pages likely due to HTTP attacks.
    // Incident & investigation ongoing.
    timeout: 2_000,
    lazy: true,
    dedupe: 'defer',
  })
}
